import { CommentReport, FullSurveyReport, segmentListsMatch, SelectionReport, SelectionSummary, SurveyAnswer, SurveyData, surveyHelper } from "..";

export const surveyReportHelper =
{
    removeAnswer,
    addAnswer,
    buildSelectionSummary,
    createNewSelectionSummary
}

function removeAnswer(survey:SurveyData, report:FullSurveyReport, answer:SurveyAnswer){
    const selectionReport = report.selectionReport.segmentReports.find(r => 
        segmentListsMatch(r.segments, answer.segments));

    if(!selectionReport)
        throw new Error('missing selectionReport for segment');

    for(let i=0; i<selectionReport.questionIndexedSummaries.length; i++){
        if(answer.selections[i].value === 1)
            selectionReport.questionIndexedSummaries[i].selectionSummary.value1Count--;
        else if(answer.selections[i].value === 2)
            selectionReport.questionIndexedSummaries[i].selectionSummary.value2Count--;
        else if(answer.selections[i].value === 3)
            selectionReport.questionIndexedSummaries[i].selectionSummary.value3Count--;
        else if(answer.selections[i].value === 4)
            selectionReport.questionIndexedSummaries[i].selectionSummary.value4Count--;
        else if(answer.selections[i].value === 5)
            selectionReport.questionIndexedSummaries[i].selectionSummary.value5Count--;
        else
            throw new Error('Invalid value:' + answer.selections[i].value);
        if(answer.selections[i].comment !== ''){
            selectionReport.questionIndexedSummaries[i].commentCount--;
        }
    }

    const commentReport = report.commentReport.segmentReports.find(r => 
        segmentListsMatch(r.segments, answer.segments));

    if(!commentReport)
        throw new Error('missing commentReport for segment');

    for(let i=0; i<commentReport.questionIndexedComments.length; i++){
        if(answer.selections[i].comment !== ''){
            const commentIndex = commentReport.questionIndexedComments[i].comments.findIndex(c => c.selection === answer.selections[i].value && c.text === answer.selections[i].comment);
            if(commentIndex < 0)
                throw new Error(`Unable to locate comment with selection:${answer.selections[i].value} and text:${answer.selections[i].comment}`);

            commentReport.questionIndexedComments[i].comments.splice(commentIndex, 1);
        }
    }
}

function addAnswer(survey:SurveyData, report:FullSurveyReport, answer:SurveyAnswer){
    const selectionReport = getOrCreateSelectionReport(survey, report, answer);
    const allQuestions = surveyHelper.getAllSurveyQuestions(survey);
    for(let i=0; i<selectionReport.questionIndexedSummaries.length; i++){
        const question = allQuestions[i];
        const isInverted = question.question.invertScore === true;
        const selection = answer.selections[i].value;
        const reportSummary = selectionReport.questionIndexedSummaries[i].selectionSummary;

        if(isInverted){
            if(selection === 5)
                reportSummary.value1Count++;
            else if(selection === 4)
                reportSummary.value2Count++;
            else if(selection === 3)
                reportSummary.value3Count++;
            else if(selection === 2)
                reportSummary.value4Count++;
            else if(selection === 1)
                reportSummary.value5Count++;
            else
                throw new Error('Invalid value:' + selection);
        }
        else{
            if(selection === 1)
                reportSummary.value1Count++;
            else if(selection === 2)
                reportSummary.value2Count++;
            else if(selection === 3)
                reportSummary.value3Count++;
            else if(selection === 4)
                reportSummary.value4Count++;
            else if(selection === 5)
                reportSummary.value5Count++;
            else
                throw new Error('Invalid value:' + selection);
        }

        if(answer.selections[i].comment !== '')
            selectionReport.questionIndexedSummaries[i].commentCount++;
    }

    const commentReport = getOrCreateCommentReport(survey, report, answer);
    for(let i=0; i<commentReport.questionIndexedComments.length; i++){
        const question = allQuestions[i];
        if(answer.selections[i].comment !== ''){
            commentReport.questionIndexedComments[i].comments.push({
                text:answer.selections[i].comment,
                selection:
                    question.question.invertScore ?
                        6 - answer.selections[i].value
                        : answer.selections[i].value
            });
        }
    }
}

function getOrCreateSelectionReport(survey:SurveyData, report:FullSurveyReport, answer:SurveyAnswer):SelectionReport{

    let existingReport = report.selectionReport.segmentReports.find(cs => 
        segmentListsMatch(cs.segments, answer.segments));
    
    if(!existingReport){
        existingReport = {
            segments:answer.segments,
            questionIndexedSummaries: 
                survey.themes.flatMap(t =>
                    t.questions.map(q => { 
                        return {
                            indicators: q.indicators.slice(),
                            selectionSummary: createNewSelectionSummary(),
                            commentCount:0
                        };
                    })
                )
        };
        report.selectionReport.segmentReports.push(existingReport);
    }
    return existingReport;
}

function getOrCreateCommentReport(survey:SurveyData, report:FullSurveyReport, answer:SurveyAnswer):CommentReport{

    let existingReport = report.commentReport.segmentReports.find(cs => 
        segmentListsMatch(cs.segments, answer.segments));
    
    if(!existingReport){
        existingReport = {
            segments:answer.segments,
            questionIndexedComments:
                survey.themes.flatMap(t =>
                    t.questions.map(() => { 
                        return {
                            comments:[]
                        };
                    })
                )
        };
        report.commentReport.segmentReports.push(existingReport);
    }
    return existingReport;
}

function buildSelectionSummary(val1:number, val2:number, val3:number, val4:number, val5:number):SelectionSummary{
    return {
        value1Count:val1,
        value2Count:val2,
        value3Count:val3,
        value4Count:val4,
        value5Count:val5,
    };
}

function createNewSelectionSummary():SelectionSummary{
    return {
        value1Count:0,
        value2Count:0,
        value3Count:0,
        value4Count:0,
        value5Count:0,
    };
}